import { cn } from "@/lib/utils";
import React from "react";

import {
  BorderGradientProps,
  borderGradient,
  resolveColor,
} from "./gradientContainerUtils";

type GradientBorderContainerProps = BorderGradientProps & {
  children: React.ReactNode;
  className?: string;
  hideBorder?: boolean;
  /** Fill color on hover. Uses same format as fill. Applied via CSS hover, no React state. */
  hoverFill?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
};

/**
 * Applies a gradient border. Uses a wrapper div so the gradient transition
 * doesn't conflict with the child's transition-colors.
 *
 * @param fill - Should match the background of the inside of the container
 *   so the gradient border blends correctly.
 */
export const GradientBorderContainer = ({
  from: fromProp,
  to: toProp,
  direction,
  width,
  fill: fillProp,
  children,
  className,
  hideBorder = false,
  hoverFill,
  onClick,
}: GradientBorderContainerProps) => {
  if (hideBorder) {
    return <>{children}</>;
  }
  const from = fromProp ?? "panel-middleground";
  const to = toProp ?? "panel-background";
  const fill = fillProp ?? "panel-background";

  const gradient = borderGradient({ from, to, direction, width, fill });

  return (
    <div
      className={cn(
        gradient.className,
        hoverFill &&
          "transition-[--border-gradient-fill] duration-200 hover:[--border-gradient-fill:var(--border-gradient-hover-fill)]",
        className,
      )}
      style={
        {
          ...gradient.style,
          ...(hoverFill && {
            "--border-gradient-hover-fill": resolveColor(hoverFill),
          }),
        } as React.CSSProperties
      }
      onClick={onClick}
    >
      {children}
    </div>
  );
};
